export enum PatientBannerEnum {
  defaultMobileHeight = 220,
  defaultDesktopHeight = 120,
  extendedMobileHeight = 280,
  extendedDesktopHeight = 250
}
